var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid",style:(("--grid-gap: var(--s" + _vm.gap + "); --grid-padY: var(--s" + _vm.padY + "); --grid-padX: var(--s" + _vm.padX + "); grid-template-columns: " + _vm.gridTemplateColumns + ";"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }